// src/blogs/blogs.js

import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom"; // 1. Import Link for routing :contentReference[oaicite:4]{index=4}
import slugify from "slugify"; // 2. Import slugify for front‑end slug generation :contentReference[oaicite:5]{index=5}
import "./blogs.scss";
import fitojaLogo from "../assets/fitoja-logo.png";
import { formatBlogDate } from "../utils/dateFormatter";

const Blogs = () => {
  const [blogs, setBlogs] = useState([]); // 3. blogs array state via useState :contentReference[oaicite:6]{index=6}
  const [loading, setLoading] = useState(true); //    loading flag state :contentReference[oaicite:7]{index=7}
  const [error, setError] = useState(null); //    error message state :contentReference[oaicite:8]{index=8}

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await fetch("https://api.fitoja.in/api/get-blogs");
        const json = await response.json();

        if (json.success) {
          let fetchedBlogs = json.data;

          // 💡 FRONTEND SORTING: Sort by creation date (latest first)
          const sortedBlogs = fetchedBlogs.sort((a, b) => {
            // Assuming 'createdAt' is a standard date string (e.g., ISO 8601)
            // Use a standard date comparison: b - a for descending (latest first)
            return new Date(b.createdAt) - new Date(a.createdAt);
          });

          setBlogs(sortedBlogs);
        } else {
          throw new Error("API returned success=false");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchBlogs();
  }, []);

  return (
    <div>
      <section className="blogs-page">
        <Helmet>
          <title id="ttl">Fitoja Blogs | Health & Fitness Insights</title>
          <meta
            name="description"
            content="Read our expert-written blogs on fitness, nutrition, and wellness on Fitoja."
          />
          <meta property="og:title" content="Fitoja Blogs" />
          <meta
            property="og:description"
            content="Expert health and fitness articles from Fitoja."
          />
          <meta property="og:image" content="/path/to/default-og-image.jpg" />
          <meta name="twitter:card" content="summary_large_image" />
        </Helmet>

        <h1 className="blogs-page__title">Health Blogs</h1>

        {loading && <p className="blogs-page__status">Loading posts...</p>}
        {error && (
          <p className="blogs-page__status blogs-page__status--error">
            {error}
          </p>
        )}

        {!loading && !error && (
          <div className="blogs-page__grid">
            {blogs.map((blog) => {
              // 4. blog declared here in map callback :contentReference[oaicite:9]{index=9}
              const slug = slugify(blog.title, {
                // 5. compute slug here, where blog is in scope :contentReference[oaicite:10]{index=10}
                lower: true,
                strict: true,
              });

              return (
                <article key={blog._id} className="blogs-page__item">
                  <img
                    src={blog.imageUrl}
                    alt={blog.title}
                    loading="lazy"
                    className="blogs-page__image"
                  />
                  <div className="blogs-page__content">
                    <h2 className="blogs-page__headline">{blog.title}</h2>
                    <p
                      className="blogs-page__excerpt"
                      dangerouslySetInnerHTML={{
                        __html: blog.content.substring(0, 150) + "...",
                      }}
                    />
                    <p className="blogs-page__date">
                      {formatBlogDate(blog.createdAt)}
                    </p>
                    <span style={{display: "flex", justifyContent: "center", width: "100%"}}>
                      <Link
                        to={`/blogs/${slug}`} // 6. use slugified title in URL :contentReference[oaicite:11]{index=11}
                        state={{ blog }} //    pass entire blog object via state :contentReference[oaicite:12]{index=12}
                        className="blogs-page__read-more"
                      >
                        Read More
                      </Link>
                    </span>
                  </div>
                </article>
              );
            })}
          </div>
        )}
      </section>
      {/* Footer */}
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-logo">
            <img src={fitojaLogo} alt="Fitoja Logo" />
            <p>Your personalized health and diet companion</p>
          </div>
          <div className="footer-links">
            <div className="link-group">
              <h3>Company</h3>
              <Link to="/about-us">About Us</Link>
              <Link to="/customer-support">Contact</Link>
              <Link to="/customer-support">Customer Support</Link>
            </div>
            <div className="link-group">
              <h3>Legal</h3>
              <Link to="/privacy-policy">Privacy Policy</Link>
              <Link to="/terms-conditions">Terms & Conditions</Link>
              {/* <Link to="/cookie-policy">Cookie Policy</Link> */}
            </div>
            <div className="link-group">
              <h3>Resources</h3>
              <Link to="/blogs">Health Blogs</Link>
              {/*  <Link to="/faq">FAQ</Link>
              <Link to="/recipes">Recipes</Link> */}
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>
            © {new Date().getFullYear()} Fitoja. All rights reserved. Designed
            for a healthier you.
          </p>
          <div className="social-links">
            <Link to="#" aria-label="Facebook">
              <i className="fab fa-facebook"></i>
            </Link>
            <Link to="#" aria-label="Instagram">
              <i className="fab fa-instagram"></i>
            </Link>
            <Link to="#" aria-label="Twitter">
              <i className="fab fa-twitter"></i>
            </Link>
            <Link to="#" aria-label="LinkedIn">
              <i className="fab fa-linkedin"></i>
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Blogs;
